<template>
  <div>

    <div class="card">
      <div class="card-body">
        <h5 class="card-title page-title">
          <slot></slot>
          <small v-if="loggedIn">
            <a class="btn btn-outline-secondary btn-sm"
               @click.prevent="createRecipe"
               href="#">Create recipe</a>
          </small>
        </h5>

        <div>
          <BaseErrors :errors="errors"></BaseErrors>
          <BaseLoader :loading="loading"/>

          <ul class="recipes-list">
            <li v-for="recipe in recipes" :class="{draft: !recipe.published }">
              <div class="date">
                <div class="day">{{recipe.created.getDate() | day}}</div>
                <div class="month">{{recipe.created.getMonth() | month}}</div>
                <div class="year">{{recipe.created.getFullYear()}}</div>
              </div>
              <div class="main-info-wrapper">
              <div class="main-text">
                <a :href="'/app/recipes/' + recipe.id">{{ recipe.name }}</a>
              </div>
              <div class="sub-text">{{ recipe.subStyle }}</div>

              <div class="meta-text">
                <span class="badge badge-light">OG {{ recipe.og | sg}}</span>
                <span class="badge badge-light">FG {{ recipe.fg | sg }}</span>
                <span class="badge badge-light">ABV {{ recipe.abv | abv }}</span>
                <span class="badge badge-light">IBU {{ recipe.ibu }}</span>
                <span class="badge badge-light">Color {{ recipe.color }}</span>
              </div>

              <div class="actions" v-if="includePrivate">
                <a
                  class="btn btn-outline-secondary btn-sm"
                  :href="'/app/recipes/' + recipe.id">View</a>

                <a class="btn btn-outline-secondary btn-sm"
                   :href="'/app/recipes/' + recipe.id + '/edit'">Edit</a>

                <a v-if="!recipe.published"
                   :data-id="recipe.id"
                   @click.prevent="publishRecipe"
                   class="btn btn-outline-secondary btn-sm"
                   href="">Publish</a>

                <a v-if="recipe.published"
                   :data-id="recipe.id"
                   class="btn btn-outline-secondary btn-sm"
                   @click.prevent="unpublishRecipe"
                   href="">UnPublish</a>

                <a :href="'/app/recipes/' + recipe.id"
                   class="btn btn-outline-secondary btn-sm"
                   :data-id="recipe.id"
                   @click.prevent="deleteRecipe">Delete</a>
              </div>
              </div>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
    import { HTTP } from '../lib/http';
    import { EventBus } from '../lib/event-bus.js';

    const toLower = text => {
        return text.toString().toLowerCase();
    };

    export default {
        name: "recipes-list",
        props: {
        },
        data() {
            return {
                recipes: undefined,
                errors: null,
                loading: true,
                loggedIn: false
            };
        },
        methods: {
            fetchRecipes() {
                let recipeUrl = this.includePrivate ? 'member-recipes' : 'recipes';
                HTTP
                    .get(recipeUrl + this.getQueryParams({sort: { createdAt: 'DSC'}}))
                    .then(response => {
                        let recipes = response.data.data;
                        _(recipes).each((rec)=> rec.created = new Date(rec.timestamp));
                        this.recipes = recipes;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },

            deleteRecipe(e) {
                if (confirm('Are you sure?')) {
                    const recipeId = e.currentTarget.getAttribute('data-id');
                    HTTP.delete("recipes/" + recipeId)
                        .then(response => {
                            this.fetchRecipes()
                        })
                        .catch(err => {
                            this.errors = [err.response.data.errors];
                        })
                }
            },

            publishRecipe(e) {
                if (confirm('Are you sure?')) {
                    const recipeId = e.currentTarget.getAttribute('data-id');
                    HTTP.patch('recipes/' + recipeId + '/publish')
                        .catch(err => {
                            this.errors = [err.response.data.errors];
                        }).then((response) => this.fetchRecipes())
                }
            },

            unpublishRecipe(e) {
                if (confirm('Are you sure?')) {
                    const recipeId = e.currentTarget.getAttribute('data-id');
                    HTTP.patch('recipes/' + recipeId + '/unpublish')
                        .catch(err => {
                            this.errors = [err.response.data.errors];
                        }).then((response) => this.fetchRecipes())
                }
            },
            createRecipe() {
                HTTP.post("recipes",
                    {data: {}})
                    .then(response => {
                       this.fetchRecipes();
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    })
            },
        },
        beforeMount() {
            this.loggedIn = !!localStorage.username;
            this.includePrivate = this.loggedIn;
            EventBus.$on('logged-in', val => {

                this.loggedIn = val;
                this.includePrivate = val;
            });
        },
        mounted() {
          this.fetchRecipes();
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "/../assets/scss/_variablesx.scss";

  $gray-base: lighten($gray-900, 15);

  .page-title .btn {
    float: right;
    font-size: .8em;
  }

  .recipes-list {
    list-style-type: none;
    padding: 0;
    margin: 0;

    & > li {
      display: flex;
      margin-bottom: 1.5em;

      &.draft {
        opacity: .5;

        &::before {
          content: "";
          border-right: 5px dotted;
          margin-right: 15px;
        }

        .main-text a::before {
          content: "[draft] ";
        }
      }

      .date {
        text-align: center;
        line-height: 1.2;
        width: 60px;
        margin-left: -15px;
        margin-top: 4px;
        text-transform: uppercase;
        color: $gray-base;

        .day {
          font-size: 1.8em;
          margin-bottom: -0.08em;
        }
        .month {
          font-size: 1.1em;
          font-weight: 700;
        }
        .year { font-weight: 700;}
      }

      .main-info-wrapper {
        .main-text {
          font-weight: 700;
          font-size: 1.5em;
        }

        .sub-text {
          margin-top: -0.2em;
          margin-bottom: 0.2em;
        }

        .meta-text {
          font-size: .9em;

          .badge {
            margin-right: .5em;
          }
        }

        .actions {
          margin-top: .5em;
          display: flex;

          & > a {
            margin-right: .5em;
            display: block;
          }
        }
      }
    }
  }

  @media (min-width: 575.98px) {
    .recipes-list {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;

      & > li {
        flex-grow: 1;
        max-width: 320px;
        margin-right: 50px;
      }

      .main-info-wrapper {
        .main-text {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 250px;
        }
      }
    }
  }

</style>
